import React from 'react'
import "../assests/help.css"

function Help() {
  const data = [
    {
      id: 1,
      title: "Addiction",
      style: "eclipse1"
    },
    {
      id: 2,
      title: "Skills",
      style: "eclipse2"
    },
    {
      id: 3,
      title: "Anxiety",
      style: "eclipse3"
    },
    {
      id: 4,
      title: "Relationship",
      style: "eclipse4"
    },
    {
      id: 5,
      title: "Depression",
      style: "eclipse5"
    },
    {
      id: 6,
      title: "Family",
      style: "eclipse6"
    },
    {
      id: 7,
      title: "Language Difficulties",
      style: "eclipse7"
    },
    {
      id: 8,
      title: "Abuse",
      style: "eclipse8"
    }
  ]
  return (
    <div>
      <div className="help">
        <h1>
        We can {" "}
        <span style={{ color: "#32BAC7" }}>
          help you {' '}
        </span>
        with
        </h1>
      </div>
      <div className="help_sections">
      {
        data.map((item) => (
          <div key={item.id} className={item.style}>
              {item.title}
          </div>
        ))
      }
      </div>
    </div>
  )
}

export default Help